// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-core-navigation-table-view {
  width: 100%;
  height: 100%;
  position: relative;
}
.dl-core-navigation-table-view__row-link-wrap {
  display: flex;
  align-items: center;
  width: 100%;
}
.dl-core-navigation-table-view__row {
  display: flex;
  align-items: center;
  padding: 0 20px;
}
.dl-core-navigation-table-view__row:hover {
  cursor: pointer;
  background: var(--g-color-base-simple-hover);
}
.dl-core-navigation-table-view__row_hovered {
  background: var(--g-color-base-simple-hover);
}
.dl-core-navigation-table-view__row_highlight {
  background: var(--g-color-base-selection);
}
.dl-core-navigation-table-view__row_hidden .dl-core-navigation-table-view__name {
  color: var(--g-color-text-utility);
}
.dl-core-navigation-table-view__row_inactive {
  cursor: default;
  pointer-events: none;
}
.dl-core-navigation-table-view__row_inactive .dl-core-navigation-table-view__name,
.dl-core-navigation-table-view__row_inactive .dl-core-navigation-table-view__icon {
  opacity: 0.5;
}
.dl-core-navigation-table-view__row_locked .dl-core-navigation-table-view__row-btns {
  visibility: hidden;
}
.dl-core-navigation-table-view__row_checked {
  background: var(--g-color-base-selection);
}
.dl-core-navigation-table-view__row_checked:hover, .dl-core-navigation-table-view__row_checked.dl-core-navigation-table-view__row_hovered {
  background: var(--g-color-base-selection-hover);
}
.dl-core-navigation-table-view__row_withCheckbox .dl-core-navigation-table-view__link {
  width: calc(100% - 30px);
}
.dl-core-navigation-table-view__row_header {
  height: 40px;
  background: var(--g-color-base-background);
  position: sticky;
  z-index: 2;
  top: 0;
  left: 0;
  width: 100%;
}
.dl-core-navigation-table-view__row_header:hover {
  background: var(--g-color-base-background);
  cursor: initial;
}
.dl-core-navigation-table-view__row_header .dl-core-navigation-table-view__name {
  font-family: var(--g-text-subheader-font-family);
  font-weight: var(--g-text-subheader-font-weight);
  font-size: var(--g-text-subheader-1-font-size);
  line-height: var(--g-text-subheader-1-line-height);
  margin-right: 12px;
  padding-left: 2px;
}
.dl-core-navigation-table-view__row_header .dl-core-navigation-table-view__createdBy {
  font-family: var(--g-text-subheader-font-family);
  font-weight: var(--g-text-subheader-font-weight);
  font-size: var(--g-text-subheader-1-font-size);
  line-height: var(--g-text-subheader-1-line-height);
  opacity: initial;
  padding: 0 10px 0 18px;
}
.dl-core-navigation-table-view__row_header .dl-core-navigation-table-view__date {
  font-family: var(--g-text-subheader-font-family);
  font-weight: var(--g-text-subheader-font-weight);
  font-size: var(--g-text-subheader-1-font-size);
  line-height: var(--g-text-subheader-1-line-height);
  opacity: initial;
  padding-right: 2px;
  color: var(--g-color-text-primary);
}
.dl-core-navigation-table-view__row_mode_modal.dl-core-navigation-table-view__row_header .dl-core-navigation-table-view__date {
  justify-content: flex-start;
  padding-left: 20px;
}
.dl-core-navigation-table-view__row_withParentFolder.dl-core-navigation-table-view__row_mode_modal.dl-core-navigation-table-view__row_header .dl-core-navigation-table-view__createdBy {
  padding: 0 10px;
}
.dl-core-navigation-table-view__row_withParentFolder.dl-core-navigation-table-view__row_header .dl-core-navigation-table-view__createdBy {
  padding: 0 10px 0 14px;
}
.dl-core-navigation-table-view__row_withParentFolder .dl-core-navigation-table-view__createdBy {
  flex: 1 0 10%;
}
.dl-core-navigation-table-view__row_withParentFolder .dl-core-navigation-table-view__parent-folder {
  flex: 0 0 30%;
}
.dl-core-navigation-table-view__row_withParentFolder .dl-core-navigation-table-view__name {
  flex: 3 1 60%;
}
.dl-core-navigation-table-view__row_mode_minimal {
  padding: 0 20px;
}
.dl-core-navigation-table-view__row_mode_minimal .dl-core-navigation-table-view__createdBy {
  display: none;
}
.dl-core-navigation-table-view__row_mode_minimal .dl-core-navigation-table-view__info {
  padding-right: 0;
}
.dl-core-navigation-table-view__row_mode_minimal .dl-core-navigation-table-view__row-btns {
  display: none;
}
.dl-core-navigation-table-view__row_mode_minimal .dl-core-navigation-table-view__date {
  flex: 0 0 60px;
  min-width: auto;
}
.dl-core-navigation-table-view__row_mode_modal .dl-core-navigation-table-view__date {
  flex: 0 0 70px;
  min-width: auto;
}
.dl-core-navigation-table-view__row-loader-more {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.dl-core-navigation-table-view__icon {
  margin-right: 12px;
  position: relative;
  flex: 0 0 auto;
}
.dl-core-navigation-table-view__info {
  width: 100%;
  display: flex;
  align-items: center;
  min-height: 40px;
  position: relative;
  padding-right: 86px;
  overflow: hidden;
}
.dl-core-navigation-table-view__row-btns {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 86px;
  padding-left: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dl-core-navigation-table-view__row-btn {
  visibility: hidden;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 4px;
}
.dl-core-navigation-table-view__row:hover .dl-core-navigation-table-view__row-btn, .dl-core-navigation-table-view__row_hovered .dl-core-navigation-table-view__row-btn {
  visibility: visible;
}
.dl-core-navigation-table-view__row-btn:hover, .dl-core-navigation-table-view__row-btn_hovered {
  background: var(--g-color-base-simple-hover);
}
.dl-core-navigation-table-view__row-btn {
  color: var(--g-color-text-secondary);
}
.dl-core-navigation-table-view__btn-change-favorite {
  visibility: hidden;
  color: var(--g-color-base-misc-heavy-hover);
}
.dl-core-navigation-table-view__btn-change-favorite_isFavorite {
  visibility: visible;
}
.dl-core-navigation-table-view__row:hover .dl-core-navigation-table-view__btn-change-favorite:not(.dl-core-navigation-table-view__btn-change-favorite_isFavorite), .dl-core-navigation-table-view__row_hovered .dl-core-navigation-table-view__btn-change-favorite:not(.dl-core-navigation-table-view__btn-change-favorite_isFavorite) {
  color: var(--g-color-text-secondary);
}
.dl-core-navigation-table-view__row:hover .dl-core-navigation-table-view__btn-change-favorite:not(.dl-core-navigation-table-view__btn-change-favorite_isFavorite) .dl-core-navigation-table-view__icon-star-stroke, .dl-core-navigation-table-view__row_hovered .dl-core-navigation-table-view__btn-change-favorite:not(.dl-core-navigation-table-view__btn-change-favorite_isFavorite) .dl-core-navigation-table-view__icon-star-stroke {
  display: block;
}
.dl-core-navigation-table-view__row:hover .dl-core-navigation-table-view__btn-change-favorite:not(.dl-core-navigation-table-view__btn-change-favorite_isFavorite) .dl-core-navigation-table-view__icon-star-fill, .dl-core-navigation-table-view__row_hovered .dl-core-navigation-table-view__btn-change-favorite:not(.dl-core-navigation-table-view__btn-change-favorite_isFavorite) .dl-core-navigation-table-view__icon-star-fill {
  display: none;
}
.dl-core-navigation-table-view__edit-favorites-alias-btn {
  visibility: hidden;
}
.dl-core-navigation-table-view__edit-favorites-alias-btn_visible {
  visibility: visible;
}
.dl-core-navigation-table-view__row:hover .dl-core-navigation-table-view__edit-favorites-alias-btn, .dl-core-navigation-table-view__row_hovered .dl-core-navigation-table-view__edit-favorites-alias-btn {
  visibility: visible;
}
.dl-core-navigation-table-view__icon-star-stroke {
  display: none;
}
.dl-core-navigation-table-view .dl-core-navigation-table-view__lock {
  margin: 2px 5px 0 10px;
  flex: 0 0 16px;
  color: var(--g-color-text-hint);
}
.dl-core-navigation-table-view__name {
  flex: 3 1 30%;
  display: flex;
  align-items: center;
  overflow: hidden;
  min-width: 100px;
  color: var(--g-color-text-primary);
}
.dl-core-navigation-table-view__name span,
.dl-core-navigation-table-view__name a {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dl-core-navigation-table-view__createdBy {
  flex: 1 0 20%;
  display: flex;
  min-width: 100px;
  overflow: hidden;
  padding: 0 10px;
}
.dl-core-navigation-table-view__date {
  flex: 0 0 140px;
  display: flex;
  justify-content: flex-end;
  color: var(--g-color-text-secondary);
  align-items: center;
  min-width: 100px;
  overflow: hidden;
}
.dl-core-navigation-table-view__date > span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dl-core-navigation-table-view__link {
  width: 100%;
}
.dl-core-navigation-table-view__link, .dl-core-navigation-table-view__link:hover, .dl-core-navigation-table-view__link:active, .dl-core-navigation-table-view__link:visited, .dl-core-navigation-table-view__link:focus {
  -webkit-text-decoration: none;
  text-decoration: none;
  outline: none;
  color: inherit;
}
.dl-core-navigation-table-view__list {
  margin-bottom: 20px;
}
.dl-core-navigation-table-view__list_showBatchPanel {
  margin-bottom: 60px;
}
.dl-core-navigation-table-view__name-line {
  display: flex;
  flex: 1 1 auto;
  line-height: 20px;
  overflow: hidden;
}
.dl-core-navigation-table-view__parent-folder {
  height: 20px;
  display: flex;
  align-items: center;
  flex: 0 0 50%;
  font-size: 13px;
  overflow: hidden;
}
.dl-core-navigation-table-view__folder-inline {
  flex: 0 0 16px;
  color: var(--g-color-text-hint);
  margin-right: 2px;
}
.dl-core-navigation-table-view__parent-folder-name {
  opacity: 0.5;
}
.dl-core-navigation-table-view__parent-folder-name:hover {
  opacity: 0.7;
}
.dl-core-navigation-table-view__selection-checkbox {
  padding-right: 14px;
  display: flex;
  align-items: center;
  align-self: stretch;
}
.dl-core-navigation-table-view__batch-panel {
  position: absolute;
  width: calc(100% - 44px);
  bottom: 8px;
  left: 22px;
}
.dl-core-navigation-table-view_mobile {
  font-family: var(--g-text-body-font-family);
  font-weight: var(--g-text-body-font-weight);
  font-size: var(--g-text-body-2-font-size);
  line-height: var(--g-text-body-2-line-height);
}
.dl-core-navigation-table-view_mobile .dl-core-navigation-table-view__icon {
  margin-right: 6px;
}
.dl-core-navigation-table-view_mobile .dl-core-navigation-table-view__row_mode_minimal {
  padding: 0 16px;
}
.dl-core-navigation-table-view_mobile .dl-core-navigation-table-view__list > .dl-core-navigation-table-view__row-container:not(:last-child) .dl-core-navigation-table-view__link {
  border-bottom: 1px solid var(--g-color-line-generic);
}`, "",{"version":3,"sources":["webpack://./src/ui/components/Navigation/Core/TableView/TableView.scss","webpack://./node_modules/@gravity-ui/uikit/styles/mixins.scss"],"names":[],"mappings":"AAEA;EAII,WAAA;EACA,YAAA;EACA,kBAAA;AAJJ;AAMI;EACI,aAAA;EACA,mBAAA;EACA,WAAA;AAJR;AAOI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;AALR;AAOQ;EACI,eAAA;EACA,4CAAA;AALZ;AAQQ;EACI,4CAAA;AANZ;AASQ;EACI,yCAAA;AAPZ;AAWY;EACI,kCAAA;AAThB;AAaQ;EACI,eAAA;EACA,oBAAA;AAXZ;AAaY;;EAEI,YAAA;AAXhB;AAgBY;EACI,kBAAA;AAdhB;AAkBQ;EACI,yCAAA;AAhBZ;AAmBQ;EAEI,+CAAA;AAlBZ;AAsBY;EACI,wBAAA;AApBhB;AAyBI;EACI,YAAA;EACA,0CAAA;EACA,gBAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;AAvBR;AAyBQ;EACI,0CAAA;EACA,eAAA;AAvBZ;AA0BQ;ECyIJ,gDAAA;EACA,gDAAA;EACA,8CAAA;EACA,kDAAA;ED1IQ,kBAAA;EACA,iBAAA;AArBZ;AAwBQ;ECmIJ,gDAAA;EACA,gDAAA;EACA,8CAAA;EACA,kDAAA;EDpIQ,gBAAA;EACA,sBAAA;AAnBZ;AAsBQ;EC6HJ,gDAAA;EACA,gDAAA;EACA,8CAAA;EACA,kDAAA;ED9HQ,gBAAA;EACA,kBAAA;EACA,kCAAA;AAjBZ;AAsBQ;EACI,2BAAA;EACA,kBAAA;AApBZ;AAyBQ;EACI,eAAA;AAvBZ;AA4BQ;EACI,sBAAA;AA1BZ;AA+BQ;EACI,aAAA;AA7BZ;AAgCQ;EACI,aAAA;AA9BZ;AAiCQ;EACI,aAAA;AA/BZ;AAmCI;EACI,eAAA;AAjCR;AAmCQ;EACI,aAAA;AAjCZ;AAoCQ;EACI,gBAAA;AAlCZ;AAqCQ;EACI,aAAA;AAnCZ;AAsCQ;EACI,cAAA;EACA,eAAA;AApCZ;AAyCQ;EACI,cAAA;EACA,eAAA;AAvCZ;AA2CI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAzCR;AA4CI;EACI,kBAAA;EACA,kBAAA;EACA,cAAA;AA1CR;AA+CI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBARW;EASX,gBAAA;AA7CR;AAgDI;EACI,kBAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,WAjBW;EAkBX,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AA9CR;AAiDI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AA/CR;AAiDQ;EAEI,mBAAA;AAhDZ;AAmDQ;EAEI,4CAAA;AAlDZ;AAqDQ;EACI,oCAAA;AAnDZ;AAuDI;EACI,kBAAA;EACA,2CAAA;AArDR;AAuDQ;EACI,mBAAA;AArDZ;AA0DY;EACI,oCAAA;AAxDhB;AA0DgB;EACI,cAAA;AAxDpB;AA2DgB;EACI,aAAA;AAzDpB;AA+DI;EACI,kBAAA;AA7DR;AA+DQ;EACI,mBAAA;AA7DZ;AAgEQ;EAEI,mBAAA;AA/DZ;AAmEI;EACI,aAAA;AAjER;AAoEI;EACI,sBAAA;EACA,cAAA;EACA,+BAAA;AAlER;AAqEI;EACI,aAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kCAAA;AAnER;AAqEQ;;ECxRJ,mBAAA;EACA,gBAAA;EACA,uBAH4B;AD0NhC;AAqEI;EACI,aAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAnER;AAsEI;EACI,eAAA;EACA,aAAA;EACA,yBAAA;EACA,oCAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AApER;AAsEQ;EC/SJ,mBAAA;EACA,gBAAA;EACA,uBAH4B;AD+OhC;AAsEI;EACI,WAAA;AApER;AAsEQ;EAKI,6BAAA;EAAA,qBAAA;EACA,aAAA;EACA,cAAA;AAxEZ;AA4EI;EACI,mBAAA;AA1ER;AA4EQ;EACI,mBAAA;AA1EZ;AA8EI;EACI,aAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AA5ER;AA+EI;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;AA7ER;AAgFI;EACI,cAAA;EACA,+BAAA;EACA,iBAAA;AA9ER;AAiFI;EACI,YAAA;AA/ER;AAiFQ;EACI,YAAA;AA/EZ;AAmFI;EACI,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAjFR;AAoFI;EACI,kBAAA;EACA,wBAAA;EACA,WAAA;EACA,UAAA;AAlFR;AAqFI;EC5MA,2CAAA;EACA,2CAAA;EACA,yCAAA;EACA,6CAAA;AD0HJ;AAkFQ;EACI,iBAAA;AAhFZ;AAmFQ;EACI,eAAA;AAjFZ;AAoFQ;EACI,oDAAA;AAlFZ","sourcesContent":[".dl-core-navigation-table-view {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n.dl-core-navigation-table-view__row-link-wrap {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n.dl-core-navigation-table-view__row {\n  display: flex;\n  align-items: center;\n  padding: 0 20px;\n}\n.dl-core-navigation-table-view__row:hover {\n  cursor: pointer;\n  background: var(--g-color-base-simple-hover);\n}\n.dl-core-navigation-table-view__row_hovered {\n  background: var(--g-color-base-simple-hover);\n}\n.dl-core-navigation-table-view__row_highlight {\n  background: var(--g-color-base-selection);\n}\n.dl-core-navigation-table-view__row_hidden .dl-core-navigation-table-view__name {\n  color: var(--g-color-text-utility);\n}\n.dl-core-navigation-table-view__row_inactive {\n  cursor: default;\n  pointer-events: none;\n}\n.dl-core-navigation-table-view__row_inactive .dl-core-navigation-table-view__name,\n.dl-core-navigation-table-view__row_inactive .dl-core-navigation-table-view__icon {\n  opacity: 0.5;\n}\n.dl-core-navigation-table-view__row_locked .dl-core-navigation-table-view__row-btns {\n  visibility: hidden;\n}\n.dl-core-navigation-table-view__row_checked {\n  background: var(--g-color-base-selection);\n}\n.dl-core-navigation-table-view__row_checked:hover, .dl-core-navigation-table-view__row_checked.dl-core-navigation-table-view__row_hovered {\n  background: var(--g-color-base-selection-hover);\n}\n.dl-core-navigation-table-view__row_withCheckbox .dl-core-navigation-table-view__link {\n  width: calc(100% - 30px);\n}\n.dl-core-navigation-table-view__row_header {\n  height: 40px;\n  background: var(--g-color-base-background);\n  position: sticky;\n  z-index: 2;\n  top: 0;\n  left: 0;\n  width: 100%;\n}\n.dl-core-navigation-table-view__row_header:hover {\n  background: var(--g-color-base-background);\n  cursor: initial;\n}\n.dl-core-navigation-table-view__row_header .dl-core-navigation-table-view__name {\n  font-family: var(--g-text-subheader-font-family);\n  font-weight: var(--g-text-subheader-font-weight);\n  font-size: var(--g-text-subheader-1-font-size);\n  line-height: var(--g-text-subheader-1-line-height);\n  margin-right: 12px;\n  padding-left: 2px;\n}\n.dl-core-navigation-table-view__row_header .dl-core-navigation-table-view__createdBy {\n  font-family: var(--g-text-subheader-font-family);\n  font-weight: var(--g-text-subheader-font-weight);\n  font-size: var(--g-text-subheader-1-font-size);\n  line-height: var(--g-text-subheader-1-line-height);\n  opacity: initial;\n  padding: 0 10px 0 18px;\n}\n.dl-core-navigation-table-view__row_header .dl-core-navigation-table-view__date {\n  font-family: var(--g-text-subheader-font-family);\n  font-weight: var(--g-text-subheader-font-weight);\n  font-size: var(--g-text-subheader-1-font-size);\n  line-height: var(--g-text-subheader-1-line-height);\n  opacity: initial;\n  padding-right: 2px;\n  color: var(--g-color-text-primary);\n}\n.dl-core-navigation-table-view__row_mode_modal.dl-core-navigation-table-view__row_header .dl-core-navigation-table-view__date {\n  justify-content: flex-start;\n  padding-left: 20px;\n}\n.dl-core-navigation-table-view__row_withParentFolder.dl-core-navigation-table-view__row_mode_modal.dl-core-navigation-table-view__row_header .dl-core-navigation-table-view__createdBy {\n  padding: 0 10px;\n}\n.dl-core-navigation-table-view__row_withParentFolder.dl-core-navigation-table-view__row_header .dl-core-navigation-table-view__createdBy {\n  padding: 0 10px 0 14px;\n}\n.dl-core-navigation-table-view__row_withParentFolder .dl-core-navigation-table-view__createdBy {\n  flex: 1 0 10%;\n}\n.dl-core-navigation-table-view__row_withParentFolder .dl-core-navigation-table-view__parent-folder {\n  flex: 0 0 30%;\n}\n.dl-core-navigation-table-view__row_withParentFolder .dl-core-navigation-table-view__name {\n  flex: 3 1 60%;\n}\n.dl-core-navigation-table-view__row_mode_minimal {\n  padding: 0 20px;\n}\n.dl-core-navigation-table-view__row_mode_minimal .dl-core-navigation-table-view__createdBy {\n  display: none;\n}\n.dl-core-navigation-table-view__row_mode_minimal .dl-core-navigation-table-view__info {\n  padding-right: 0;\n}\n.dl-core-navigation-table-view__row_mode_minimal .dl-core-navigation-table-view__row-btns {\n  display: none;\n}\n.dl-core-navigation-table-view__row_mode_minimal .dl-core-navigation-table-view__date {\n  flex: 0 0 60px;\n  min-width: auto;\n}\n.dl-core-navigation-table-view__row_mode_modal .dl-core-navigation-table-view__date {\n  flex: 0 0 70px;\n  min-width: auto;\n}\n.dl-core-navigation-table-view__row-loader-more {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n.dl-core-navigation-table-view__icon {\n  margin-right: 12px;\n  position: relative;\n  flex: 0 0 auto;\n}\n.dl-core-navigation-table-view__info {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  min-height: 40px;\n  position: relative;\n  padding-right: 86px;\n  overflow: hidden;\n}\n.dl-core-navigation-table-view__row-btns {\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  width: 86px;\n  padding-left: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.dl-core-navigation-table-view__row-btn {\n  visibility: hidden;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: 4px;\n}\n.dl-core-navigation-table-view__row:hover .dl-core-navigation-table-view__row-btn, .dl-core-navigation-table-view__row_hovered .dl-core-navigation-table-view__row-btn {\n  visibility: visible;\n}\n.dl-core-navigation-table-view__row-btn:hover, .dl-core-navigation-table-view__row-btn_hovered {\n  background: var(--g-color-base-simple-hover);\n}\n.dl-core-navigation-table-view__row-btn {\n  color: var(--g-color-text-secondary);\n}\n.dl-core-navigation-table-view__btn-change-favorite {\n  visibility: hidden;\n  color: var(--g-color-base-misc-heavy-hover);\n}\n.dl-core-navigation-table-view__btn-change-favorite_isFavorite {\n  visibility: visible;\n}\n.dl-core-navigation-table-view__row:hover .dl-core-navigation-table-view__btn-change-favorite:not(.dl-core-navigation-table-view__btn-change-favorite_isFavorite), .dl-core-navigation-table-view__row_hovered .dl-core-navigation-table-view__btn-change-favorite:not(.dl-core-navigation-table-view__btn-change-favorite_isFavorite) {\n  color: var(--g-color-text-secondary);\n}\n.dl-core-navigation-table-view__row:hover .dl-core-navigation-table-view__btn-change-favorite:not(.dl-core-navigation-table-view__btn-change-favorite_isFavorite) .dl-core-navigation-table-view__icon-star-stroke, .dl-core-navigation-table-view__row_hovered .dl-core-navigation-table-view__btn-change-favorite:not(.dl-core-navigation-table-view__btn-change-favorite_isFavorite) .dl-core-navigation-table-view__icon-star-stroke {\n  display: block;\n}\n.dl-core-navigation-table-view__row:hover .dl-core-navigation-table-view__btn-change-favorite:not(.dl-core-navigation-table-view__btn-change-favorite_isFavorite) .dl-core-navigation-table-view__icon-star-fill, .dl-core-navigation-table-view__row_hovered .dl-core-navigation-table-view__btn-change-favorite:not(.dl-core-navigation-table-view__btn-change-favorite_isFavorite) .dl-core-navigation-table-view__icon-star-fill {\n  display: none;\n}\n.dl-core-navigation-table-view__edit-favorites-alias-btn {\n  visibility: hidden;\n}\n.dl-core-navigation-table-view__edit-favorites-alias-btn_visible {\n  visibility: visible;\n}\n.dl-core-navigation-table-view__row:hover .dl-core-navigation-table-view__edit-favorites-alias-btn, .dl-core-navigation-table-view__row_hovered .dl-core-navigation-table-view__edit-favorites-alias-btn {\n  visibility: visible;\n}\n.dl-core-navigation-table-view__icon-star-stroke {\n  display: none;\n}\n.dl-core-navigation-table-view .dl-core-navigation-table-view__lock {\n  margin: 2px 5px 0 10px;\n  flex: 0 0 16px;\n  color: var(--g-color-text-hint);\n}\n.dl-core-navigation-table-view__name {\n  flex: 3 1 30%;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  min-width: 100px;\n  color: var(--g-color-text-primary);\n}\n.dl-core-navigation-table-view__name span,\n.dl-core-navigation-table-view__name a {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.dl-core-navigation-table-view__createdBy {\n  flex: 1 0 20%;\n  display: flex;\n  min-width: 100px;\n  overflow: hidden;\n  padding: 0 10px;\n}\n.dl-core-navigation-table-view__date {\n  flex: 0 0 140px;\n  display: flex;\n  justify-content: flex-end;\n  color: var(--g-color-text-secondary);\n  align-items: center;\n  min-width: 100px;\n  overflow: hidden;\n}\n.dl-core-navigation-table-view__date > span {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.dl-core-navigation-table-view__link {\n  width: 100%;\n}\n.dl-core-navigation-table-view__link, .dl-core-navigation-table-view__link:hover, .dl-core-navigation-table-view__link:active, .dl-core-navigation-table-view__link:visited, .dl-core-navigation-table-view__link:focus {\n  text-decoration: none;\n  outline: none;\n  color: inherit;\n}\n.dl-core-navigation-table-view__list {\n  margin-bottom: 20px;\n}\n.dl-core-navigation-table-view__list_showBatchPanel {\n  margin-bottom: 60px;\n}\n.dl-core-navigation-table-view__name-line {\n  display: flex;\n  flex: 1 1 auto;\n  line-height: 20px;\n  overflow: hidden;\n}\n.dl-core-navigation-table-view__parent-folder {\n  height: 20px;\n  display: flex;\n  align-items: center;\n  flex: 0 0 50%;\n  font-size: 13px;\n  overflow: hidden;\n}\n.dl-core-navigation-table-view__folder-inline {\n  flex: 0 0 16px;\n  color: var(--g-color-text-hint);\n  margin-right: 2px;\n}\n.dl-core-navigation-table-view__parent-folder-name {\n  opacity: 0.5;\n}\n.dl-core-navigation-table-view__parent-folder-name:hover {\n  opacity: 0.7;\n}\n.dl-core-navigation-table-view__selection-checkbox {\n  padding-right: 14px;\n  display: flex;\n  align-items: center;\n  align-self: stretch;\n}\n.dl-core-navigation-table-view__batch-panel {\n  position: absolute;\n  width: calc(100% - 44px);\n  bottom: 8px;\n  left: 22px;\n}\n.dl-core-navigation-table-view_mobile {\n  font-family: var(--g-text-body-font-family);\n  font-weight: var(--g-text-body-font-weight);\n  font-size: var(--g-text-body-2-font-size);\n  line-height: var(--g-text-body-2-line-height);\n}\n.dl-core-navigation-table-view_mobile .dl-core-navigation-table-view__icon {\n  margin-right: 6px;\n}\n.dl-core-navigation-table-view_mobile .dl-core-navigation-table-view__row_mode_minimal {\n  padding: 0 16px;\n}\n.dl-core-navigation-table-view_mobile .dl-core-navigation-table-view__list > .dl-core-navigation-table-view__row-container:not(:last-child) .dl-core-navigation-table-view__link {\n  border-bottom: 1px solid var(--g-color-line-generic);\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
